import { Injectable } from '@angular/core';

import { map, shareReplay, switchMap, take } from 'rxjs';

import { ALL_ECUS_QUERY } from 'src/graphql/queries/abstraction-layer-queries';
import { ECU } from 'src/models/ecu';
import { ApolloService } from 'src/services/apollo.service';
import { BaseAPIService } from 'src/services/base-api.service';

@Injectable({
	providedIn: 'root',
})
export class EcuService extends BaseAPIService {
	public allEcus$ = this.apolloService.abstractionLayerClient$.pipe(
		take(1),
		switchMap(client =>
			client.query<{ ecus: ECU[] }>({
				query: ALL_ECUS_QUERY,
			}),
		),
		map(result => result.data.ecus ?? []),
		shareReplay({ bufferSize: 1, refCount: false }),
	);

	constructor(private apolloService: ApolloService) {
		super();
	}
}
